<div class="col-sm-11 center-block">
    <div class="row">
        <div *ngIf="!loggedIn" id="loading" ></div>
        <div *ngIf="loggedIn">
            <app-dashboard [userName]="userName"></app-dashboard>
        </div>
    </div>
</div>
